export const isOnServer = () => {
  if (typeof window === "undefined") {
    return true;
  }
  return false;
};
